import React from 'react';
import TripTab from "../../common/TripTab";

const days = [
    {
        day: 'day1',
        activities: 'norway_activity_d1'
    },
    {
        day: 'day2',
        activities: 'norway_activity_d2'
    },
    {
        day: 'day3',
        activities: 'norway_activity_d3'
    },
    {
        day: 'day4',
        activities: 'norway_activity_d4'
    },
    {
        day: 'day5',
        activities: 'norway_activity_d5'
    }
];

const NorwayTripTap = () => {
    return (
        <TripTab days={days}/>
    );
};

export default NorwayTripTap;

